import { Navigate } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/hooks/useAuth';

export default function AuthCallback() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (isAuthenticated && user) {
    return <Navigate to={user.isActive ? '/' : '/pending-activation'} replace />;
  }

  return <Navigate to="/login" replace />;
}
